import PV from "../utility/petite-vue";

export function initializePV(event){
    PV.mount('body');
}